export default {
  saveLayoutContainerFieldSet (layoutContainerFieldSet) {
    return this.saveItem('layout_container_field_sets', layoutContainerFieldSet)
  },
}
